<template>
  <dashboard-module class="dashboard-item" title-slot v-loading="loading">
    <template #title>
      <i class="el-icon-pie-chart title-icon"></i>
      <span class="title-text">员工薪酬水平</span>
    </template>
    <template #ope>
      <div class="flex">
        <div class="select-v2">
          <el-select class="query-item" v-model="queryParams.chartType" filterable @change="initChart">
            <el-option v-for="item in typeList" :key="item.value" :value="item.value" :label="item.label" />
          </el-select>
        </div>
        <el-radio-group class="radio-theme ml16" v-model="queryParams.type" text-color="#fff" fill="#FF9601" size="small" @change="typeChange">
          <el-radio-button label="1">实际</el-radio-button>
          <el-radio-button label="2">归属</el-radio-button>
        </el-radio-group>
      </div>
      <div></div>
    </template>
    <div class="chart" id="salaryChart"></div>
  </dashboard-module>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DashboardModule from './DashboardModule'
  import { validatenull } from "@/util/validate";
  import { getEmployeeSalaryLevelDistribution } from '@/api/v2/stats/data-center/dashboard'
  export default {
    name: "Salary",
    components: {
      DashboardModule
    },
    mounted() {
      this.$nextTick(() => {
        this.initYear()
        this.getData()
      })
    },
    data() {
      return {
        loading: false,
        years: [],
        typeList: [
          { value: 1, label: '按饼图展示' },
          { value: 2, label: '按柱状图展示' }
        ],
        queryParams: {
          chartType: 2,
          type: '1'
        },
        chart: null,
        optionPie: {
          tooltip: {
            trigger: 'item',
            enterable: true,
            formatter: (params) => {
              const { rangeDetail } = params.data
              if (!validatenull(rangeDetail)) {
                const users = rangeDetail.split(',')
                return `<div class="user-list" style="width: 150px; padding-left: 10px; max-height: 300px; overflow-y: auto">${ this.getUsersStr(users) }</div>`
              }
            }
          },
          legend: {
            type: 'scroll',
            orient: 'horizontal',
            bottom: 10
          },
          title: [
            {
              text: '2025年预计',
              left: '16.67%',
              top: '0',
              textAlign: 'center'
            },
            {
              text: '2024年实际',
              left: '50%',
              top: '0',
              textAlign: 'center'
            },
            {
              text: '2023年实际',
              left: '83.33%',
              top: '0',
              textAlign: 'center'
            }
          ],
          series: [
            {
              type: 'pie',
              radius: ['30%', '50%'],
              data: [],
              label: {
                show: true,
                position: 'outer',
                alignTo: 'labelLine',
                formatter: '{c}人({d}%)'
              },
              right: '66.6667%',
              itemStyle: {
                borderColor: '#fff'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 18,
                  fontWeight: 'bold'
                }
              }
            },
            {
              type: 'pie',
              radius: ['30%', '50%'],
              data: [],
              label: {
                show: true,
                position: 'outer',
                alignTo: 'labelLine',
                formatter: '{c}人 ({d}%)'
              },
              itemStyle: {
                borderColor: '#fff'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 18,
                  fontWeight: 'bold'
                }
              }
            },
            {
              type: 'pie',
              radius: ['30%', '50%'],
              data: [],
              label: {
                show: true,
                position: 'outer',
                alignTo: 'labelLine',
                formatter: '{c}人 ({d}%)'
              },
              left: '66.6667%',
              itemStyle: {
                borderColor: '#fff'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 18,
                  fontWeight: 'bold'
                }
              }
            }
          ]
        },
        optionBar: {
          grid: {
            left: '1%',
            right: '2%',
            bottom: '10',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            },
            enterable: true,
            formatter: (params) => {
              let moduleStr = ''
              params.forEach(module => {
                const { seriesName } = module
                const moduleData = module.data
                const { rangeDetail } = moduleData
                let users = []
                if (!validatenull(rangeDetail)) {
                  users = rangeDetail.split(',')
                }
                moduleStr += `
                  <dl style="width: 150px; padding: 6px;">
                    <dt class="mb5" style="font-weight: bold; ">${ seriesName }: ${ moduleData.value }人</dt>
                    <dd>${ this.getUsersStr(users, 'bar') }</dd>
                  </dl>
                `
              })
              return `
                <div style="display: flex; max-height: 300px; overflow-y: auto">${ moduleStr }</div>
              `
            }
          },
          legend: {
            // right: 0
          },
          xAxis: {
            type: 'category',
            axisLine: {
              lineStyle: {
                color: '#d9d9d9',
              }
            },
            axisTick: {
              alignWithLabel: true,
              lineStyle: {
                color: '#d9d9d9'
              }
            },
            axisLabel: {
              color: '#333',
              lineHeight: 24,
              interval: 0,
            },
            data: [],
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              formatter: '{value}人'
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          },
          series: [
            {
              type: 'bar',
              barWidth: '20px',
              label: {
                normal: {
                  show: true,
                  position: "top"
                }
              },
              data: []
            },
            {
              type: 'bar',
              barWidth: '20px',
              label: {
                normal: {
                  show: true,
                  position: "top"
                }
              },
              data: []
            },
            {
              type: 'bar',
              barWidth: '20px',
              label: {
                normal: {
                  show: true,
                  position: "top"
                }
              },
              data: []
            }
          ]
        },
        allData: {},
        filterData: {
          data0: [],
          data1: [],
          data2: []
        }
      }
    },
    methods: {
      initYear() {
        const currentYear = new Date().getFullYear()
        this.years = [currentYear, currentYear - 1, currentYear - 2]
      },
      // 获取数据
      getData() {
        this.loading = true
        const params = {
          month: this.$day().format('YYYY-MM')
        }
        getEmployeeSalaryLevelDistribution(params)
          .then(res => {
            this.loading = false
            const result = res.data.data
            this.allData = result
            this.typeChange()
          })
          .catch(error => this.loading = false)
      },
      // 渲染图表
      initChart() {
        let chartDom = document.getElementById("salaryChart");
        if (chartDom == null) {
          return
        }
        this.$echarts.dispose(chartDom);
        let myChart = this.$echarts.init(chartDom, { color: this.colorListPie });
        const option = this.queryParams.chartType == 1 ? { ...this.optionPie } : { ...this.optionBar }
        myChart.setOption(option);
      },
      // 组装图表数据
      chartTypeChange() {
        let xAxisData = []
        this.years.forEach((item, index) => {
          const currentData = this.filterData[`data${ index }`]
          if (!validatenull(currentData)) {
            xAxisData = currentData.map(item => item.incomeRange)
          }
          const dataItem = currentData.map(item => {
            return {
              name: item.incomeRange,
              value: item.rangeNum,
              rangeDetail: item.rangeDetail
            }
          })
          this.optionPie.series[index].data = dataItem
          this.optionBar.series[index].data = dataItem
        })
        this.optionBar.xAxis.data = xAxisData
        this.initChart()
      },
      // 根据筛选项过滤需要数据
      typeChange() {
        this.optionPie.title.forEach((item, index) => {
          const firstTitle = index == 0 ? '预计' : '实际'
          item.text = `${ this.years[index] }年${ this.queryParams.type == 1 ? firstTitle : '归属' }`
        })
        this.optionBar.series.forEach((item, index) => {
          const firstTitle = index == 0 ? '预计' : '实际'
          item.name = `${ this.years[index] }年${ this.queryParams.type == 1 ? firstTitle : '归属' }`
        })
        const { currentReckon, currentReckonBelong, lastYearReal, lastYearRealBelong, lastTwoYearReal, lastTwoYearRealBelong } = this.allData
        if (this.queryParams.type == 1) {
          this.filterData.data0 = currentReckon
          this.filterData.data1 = lastYearReal
          this.filterData.data2 = lastTwoYearReal
        } else {
          this.filterData.data0 = currentReckonBelong
          this.filterData.data1 = lastYearRealBelong
          this.filterData.data2 = lastTwoYearRealBelong
        }
        this.chartTypeChange()
      },
      getUsersStr(users) {
        if (!validatenull(users)) {
          let userStr = ''
          users.forEach(user => {
            userStr += `<p class="mb5 user-name">${ user }</p>`
          })
          return userStr
        }
      }
    },
    computed: {
      ...mapGetters(['colorListPie'])
    }
  }
</script>

<style lang="scss" scoped>
  .chart {
    height: 400px;
  }
  .query-item {
    width: 130px;
  }
</style>
